<script lang="ts">
    
    import { userTypes } from "../../environment";

    export let typeId: number;

    let typeName = '';

    $: updateName(typeId);

    function updateName(typeId: number): void {
        const type = userTypes.find(({ id }) => id === typeId);
        typeName = type?.name ?? '';
    }

</script>

{typeName}
